import React from "react";
import like from "./assets/like.svg";
import share from "./assets/share.svg";
import styles from "./NewsHeadline.module.scss";
import { SwitchBar } from "../components/SwitchBar/SwitchBar";
import { Img } from "../ImgV2/Img";
import { get } from "lodash";
export function NewsHeadline(props) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SwitchBar, {
    sliderCount: props.news_list.length
  }, props.news_list.map(function (item, index) {
    return /*#__PURE__*/React.createElement(NewsItemView, {
      key: index,
      newsModel: item
    });
  })));
}
export function NewsItemView(props) {
  var _props$newsModel$sour, _props$newsModel$sour2;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.itemBox
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.headerBox
  }, /*#__PURE__*/React.createElement(Img, {
    imgKey: get(props, "newsModel.news_image", ""),
    className: "newsHeadlineImg"
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.headerContentBox
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, props.newsModel.news_title), /*#__PURE__*/React.createElement("div", {
    className: styles.toolBox
  }, /*#__PURE__*/React.createElement("img", {
    src: like
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.line
  }), /*#__PURE__*/React.createElement("img", {
    src: share
  })))), /*#__PURE__*/React.createElement("div", {
    className: styles.bottomBox
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, props.newsModel.news_description), /*#__PURE__*/React.createElement("div", {
    className: styles.newsAgencyBox
  }, /*#__PURE__*/React.createElement("img", {
    src: (_props$newsModel$sour = props.newsModel.source) === null || _props$newsModel$sour === void 0 ? void 0 : _props$newsModel$sour.source_icon
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.agencyName
  }, (_props$newsModel$sour2 = props.newsModel.source) === null || _props$newsModel$sour2 === void 0 ? void 0 : _props$newsModel$sour2.source_text))));
}